import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MunicipalWasteState } from '../reducers/municipal-waste.reducer';

export const selectMunicipalWasteState = createFeatureSelector<MunicipalWasteState>('municipalWaste');

export const selectCollection = createSelector(selectMunicipalWasteState, state => state.collection);

export const selectScheduleCollection = createSelector(selectMunicipalWasteState, state => state.scheduleCollection);

export const selectAreaItemById = (id: string) => createSelector(selectCollection, state => state.filter(v => v.uuid === id).at(0) || null);

export const selectLoading = createSelector(selectMunicipalWasteState, state => state.loading > 0);

export const selectPending = createSelector(selectMunicipalWasteState, state => state.pending > 0);
